import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Three themes based on the top-level section
// - 'kopy'     → generic Kwik Kopy landing (black / cream backdrop)
// - 'signs'    → blue theme (/signs, /corflute, /foamboard)
// - 'stickers' → red theme (everything else)

const SIGNS_PREFIXES = ["/signs", "/corflute", "/foamboard", "/pvc", "/pull-up-banners", "/coasters", "/flags", "/a-frames", "/media-walls"];
const KOPY_PATHS = new Set(["/", "/how-it-works", "/about", "/faq", "/cart", "/checkout", "/admin"]);

export function themeFor(pathname) {
  if (SIGNS_PREFIXES.some((p) => pathname.startsWith(p))) return "signs";
  // Order-confirmation stays neutral too
  if (pathname.startsWith("/order/")) return "kopy";
  if (KOPY_PATHS.has(pathname)) return "kopy";
  return "stickers";
}

export function isSignsPath(pathname) {
  return themeFor(pathname) === "signs";
}

export function ThemeManager() {
  const loc = useLocation();
  const theme = themeFor(loc.pathname);
  useEffect(() => {
    const el = document.documentElement;
    el.classList.toggle("theme-signs", theme === "signs");
    el.classList.toggle("theme-kopy", theme === "kopy");
    document.title = { signs: "Kwik Signs", stickers: "Kwik Stickers", kopy: "Kwik Kopy" }[theme];
    return () => { el.classList.remove("theme-signs"); el.classList.remove("theme-kopy"); };
  }, [theme]);
  return null;
}

export function useBrand() {
  const loc = useLocation();
  const theme = themeFor(loc.pathname);
  const isSigns = theme === "signs";
  const isKopy = theme === "kopy";
  return {
    theme,
    isSigns,
    isKopy,
    isStickers: theme === "stickers",
    brandName: isSigns ? "Kwik Signs" : isKopy ? "Kwik Kopy Shellharbour" : "Kwik Stickers",
    brandSlug: isSigns ? "kwik-signs" : isKopy ? "kwik-kopy" : "kwik-stickers",
    brandColor: isSigns ? "#003DA5" : isKopy ? "#111315" : "#E4002B",
  };
}
